
import { Progress } from '@/components/ui/progress';

interface ProgressIndicatorProps {
  currentQuestionIndex: number;
  totalQuestions: number;
}

const ProgressIndicator = ({ currentQuestionIndex, totalQuestions }: ProgressIndicatorProps) => {
  // Calculate progress percentage
  const progress = totalQuestions > 0 
    ? ((currentQuestionIndex + 1) / totalQuestions) * 100 
    : 0;
    
  return (
    <div className="w-full max-w-3xl mb-6">
      <div className="flex justify-between text-sm text-gray-600 mb-2">
        <span>Question {currentQuestionIndex + 1} of {totalQuestions}</span>
        <span>{Math.round(progress)}% Complete</span>
      </div>
      <Progress value={progress} className="h-2" />
    </div>
  );
};

export default ProgressIndicator;
